import { StateCreator } from 'zustand';

// This is a placeholder the states will be updated during development.
export interface IssueLocationSlice {
  postcodeOrStreetName: string;
  updatePostcodeOrStreetName: (postcodeOrStreetName: string) => void;
}

export const createIssueLocationSlice: StateCreator<
  IssueLocationSlice,
  [],
  [],
  IssueLocationSlice
> = (set) => ({
  postcodeOrStreetName: '',
  updatePostcodeOrStreetName: (postcodeOrStreetName) =>
    set(() => ({ postcodeOrStreetName })),
});
